import React, { useState, useEffect } from 'react'
import MainContainer from '../UI/MainContainer'
import TableContainer from '../UI/TableContainer'
import TableSection from '../UI/TableSection'
import TableHeader from '../UI/TableHeader'
// import SearchIcon from '@material-ui/icons/SearchOutlined'
// import XIcon from '@material-ui/icons/CloseOutlined'
import DispatchItem from './Components/DispatchItem'
import { AnalyticEvent } from '../analytics/GoogleAnalytics'
import { getDispatches, getDriverDispatches, createDispatch, cancelDispatch } from './Store/actions'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setSnackBarCopy, toggleSnackBar } from '../UI/Store/actions'
import CreateOrEditDispatch from './Modals/CreateOrEditDispatch'
import ViewDispatch from './Modals/ViewDispatch'
import Snackbar from '../UI/Snackbar'
import SmConfirmModal from 'UI/SmConfirmModal'
import CancelDispatch from './Modals/CancelDispatch'
import CancelledNotes from './Modals/CancelledNotes'
import TableTopSection from 'UI/TableTopSection'

const Dispatches = props => {
  // const [searchValue, setSearchValue] = useState('')
  const [searchedValue, setSearchedValue] = useState('')
  const [searchFilter, setSearchFilter] = useState(false)
  const [dispatchList, setDispatchList] = useState(props.dispatches.dispatchList)
  const [activeFilter, setActiveFilter] = useState({ value: 'today', label: 'Today' })
  const [modalFunction, setModalFunction] = useState('new') // edit, new, view
  const [createOrEditDispatchModal, setCreateOrEditDispatchModal] = useState(false)
  const [viewDispatchModal, setViewDispatchModal] = useState(false)
  const [currentDispatch, setCurrentDispatch] = useState()
  const [currentDrivers, setCurrentDrivers] = useState()
  const [cancelDispatchModal, setCancelDispatchModal] = useState(false)
  const [cancelDispatchNotesModal, setCancelDispatchNotesModal] = useState(false)
  const [cancelledNotes, setCancelledNotes] = useState('')
  const [cancelledNotesModal, setCancelledNotesModal] = useState(false)

  const loadAllDispatches = () => {
    setDispatchList(props.dispatches.dispatchList)
  }

  const handleModalFunction = func => {
    setModalFunction(func)
  }

  const handleCancelDispatchClick = _id => {
    const dispatchDetails = props.dispatches.dispatchList.find(dispatch => dispatch._id === _id)
    const drivers = props.dispatches.driverDispatchList.filter(item => item.dispatchId === _id)
    setCurrentDrivers(drivers)
    setCurrentDispatch(dispatchDetails)
    setCancelDispatchModal(true)
  }

  const handleConfirmCancelDispatch = () => {
    setCancelDispatchModal(false)
    setCancelDispatchNotesModal(true)
  }

  const handleNotesClick = _id => {
    const dispatchDetails = props.dispatches.dispatchList.find(dispatch => dispatch._id === _id)
    setCurrentDispatch(dispatchDetails)
    setCancelledNotesModal(true)
  }

  const handleCancelDispatch = () => {
    props.cancelDispatch({ ...currentDispatch, cancelledNotes })
    setCancelDispatchNotesModal(false)
    setCurrentDrivers()
    setCurrentDispatch()
    props.setSnackBarCopy('Dispatch Cancelled')
    handleSnackBar()
  }

  const handleAddOrEditDispatch = payload => {
    props.setSnackBarCopy('New Dispatch Created')

    props.createDispatch(payload)
    loadAllDispatches()

    createOrEditDispatchModalToggle()
    handleSnackBar()
  }

  const handleSnackBar = () => {
    props.toggleSnackBar(true)
    setTimeout(() => {
      props.toggleSnackBar(false)
    }, 2500)
  }

  const createOrEditDispatchModalToggle = (type, _id) => {
    if (createOrEditDispatchModal) {
      return setCreateOrEditDispatchModal(false)
    }
    if (_id) {
      //
    }
    if (viewDispatchModal) {
      setViewDispatchModal(false)
    }
    handleModalFunction(type)
    setCreateOrEditDispatchModal(!createOrEditDispatchModal)
  }

  const viewDispatchModalToggle = _id => {
    if (viewDispatchModal) {
      return setViewDispatchModal(false)
    }
    const dispatchDetails = props.dispatches.dispatchList.find(dispatch => dispatch._id === _id)
    const drivers = props.dispatches.driverDispatchList.filter(item => item.dispatchId === _id)
    setCurrentDrivers(drivers)
    setCurrentDispatch(dispatchDetails)
    if (dispatchDetails) {
      setViewDispatchModal(true)
    }
  }

  const handleEditModalToggle = () => {
    setViewDispatchModal(false)
    setModalFunction('edit')
    setCreateOrEditDispatchModal(true)
  }

  const filterDispatches = filterType => {
    switch (filterType.value) {
      case 'today':
        AnalyticEvent('Dispatches', 'FilterTodayButtonPress')
        loadAllDispatches()
        setActiveFilter(filterType)
        break
      default:
        break
    }
  }

  useEffect(() => {
    props.getDispatches(true)
    props.getDriverDispatches(true)
    loadAllDispatches()
  }, [props.loading]) //eslint-disable-line

  const view = (type, mainView) => {
    return (
      <span className="haulViewTitle">
        View:<span className="haulViewType">{type}</span>
      </span>
    )
  }
  return (
    <MainContainer>
      <TableContainer>
        <TableTopSection
          title="Dispatches"
          loading={props.loading}
          handlePlusIconClick={() => createOrEditDispatchModalToggle('new')}
          searchString={
            !props.dispatches.loading ? (
              <p style={{ fontSize: '0.875rem', color: '#9EA0A5', padding: '0 15px' }}>
                {!searchFilter &&
                  props.dispatches.dispatchList &&
                  searchedValue.length === 0 &&
                  `${props.dispatches.dispatchList.length} Dispatches`}
                {!props.dispatches.dispatchList && `0 Dispatches`}
                {searchFilter &&
                  `${dispatchList.length}  ${
                    dispatchList.length > 1 ? 'Dispatches' : 'Dispatch'
                  } found for '${searchedValue}'`}
              </p>
            ) : (
              undefined
            )
          }
        />

        <TableSection>
          <thead>
            <tr>
              {['DATE', 'PROJECT', 'PICK UP', 'DROP OFF', 'TRUCK ASSIGNMENTS', ''].map(
                (item, i) => (
                  <TableHeader title={item} key={i} />
                )
              )}
            </tr>
          </thead>
          <tbody>
            {!props.dispatches.loading &&
              props.dispatches.dispatchList.map((dispatch, index) => {
                const driverDispatchItems = props.dispatches.driverDispatchList.filter(
                  item => item.dispatchId === dispatch._id
                )
                return (
                  <DispatchItem
                    key={index}
                    dispatch={dispatch}
                    history={props.history}
                    index={index}
                    viewDispatchModalToggle={viewDispatchModalToggle}
                    driverDispatchItems={driverDispatchItems}
                    handleCancelDispatchClick={handleCancelDispatchClick}
                    handleNotesClick={handleNotesClick}
                  />
                )
              })}
          </tbody>
        </TableSection>
      </TableContainer>
      {//modals
      createOrEditDispatchModal && (
        <CreateOrEditDispatch
          createOrEditDispatchModalToggle={createOrEditDispatchModalToggle}
          modalFunction={modalFunction}
          projects={props.projects}
          hauls={props.hauls}
          sites={props.sites}
          drivers={props.drivers}
          createDispatch={handleAddOrEditDispatch}
          dispatchDetail={currentDispatch}
        />
      )}
      {viewDispatchModal && (
        <ViewDispatch
          dispatchDetail={currentDispatch}
          viewDispatchModalToggle={viewDispatchModalToggle}
          createOrEditDispatchModalToggle={createOrEditDispatchModalToggle}
          drivers={currentDrivers}
          handleEditModalToggle={handleEditModalToggle}
        />
      )}
      {cancelDispatchModal && (
        <SmConfirmModal
          heading="Cancel Dispatch?"
          text="Are you sure you want to cancel this dispatch?"
          onCloseClick={() => setCancelDispatchModal(false)}
          onOKClick={handleConfirmCancelDispatch}
        />
      )}
      {cancelDispatchNotesModal && (
        <CancelDispatch
          cancelDispatch={handleCancelDispatch}
          setCancelledNotes={setCancelledNotes}
          cancelledNotes={cancelledNotes}
          handleCloseModal={() => setCancelDispatchNotesModal(false)}
        />
      )}
      {cancelledNotesModal && (
        <CancelledNotes
          cancelledNotes={currentDispatch.cancelledNotes}
          handleCloseModal={() => setCancelledNotesModal(false)}
        />
      )}
      {props.snackBarVisible && <Snackbar text={props.snackBarCopy} />}
    </MainContainer>
  )
}

const mapStateToProps = state => {
  return {
    dispatches: state.dispatches,
    projects: state.projects.projectList,
    hauls: state.hauls.haulList,
    sites: state.sites.siteList,
    drivers: state.drivers.driverList,
    snackBarCopy: state.ui.snackBarCopy,
    snackBarVisible: state.ui.snackBarVisible,
    loading: state.dispatches.loading
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getDispatches,
      createDispatch,
      setSnackBarCopy,
      toggleSnackBar,
      getDriverDispatches,
      cancelDispatch
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Dispatches)
